;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Anchor } from '@qogita/ui/v2/anchor'
import { EMAILS } from 'src/core/constants/copy'

export function SupportEmailLink() {
  return (
    <Anchor variant="inline-text" href={`mailto:${EMAILS.support}`}>
      {EMAILS.support}
    </Anchor>
  )
}
